import { uploadNewsFiles as uploadFiles } from "../utils/fileUtils";

export const fileManagementService = {
  uploadNewsFiles: async ({ img, preview }) => {
    return uploadFiles({ img, preview });
  },
};

export default fileManagementService;